/**
 * @readonly
 * @enum {string}
 */
module.exports = {
    PROMO_CODE: 'promo_code',
    VOUCHER: 'voucher',
};

